module.exports = __webpack_public_path__ + "media/images/business-83760d6b.svg";